import { QueryApiService } from 'src/common/api-service';
import { AuditableEntity } from '../common';

export interface Language extends AuditableEntity<number> {
  name: string;
  code: string;
}

export class LanguageApiService extends QueryApiService<Language> {
  constructor() {
    super('languages');
  }
}
